import { render, staticRenderFns } from "./OrganismIdcManagement.vue?vue&type=template&id=f7a34658&scoped=true&"
import script from "./OrganismIdcManagement.vue?vue&type=script&lang=js&"
export * from "./OrganismIdcManagement.vue?vue&type=script&lang=js&"
import style0 from "./OrganismIdcManagement.vue?vue&type=style&index=0&id=f7a34658&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7a34658",
  null
  
)

export default component.exports